export const selectAllCampers = state => state.campers.campers;

export const selectIsLoading = state => state.campers.isLoading;

export const selectedCamper = state => state.campers.selectedCamper;

export const selectError = state => state.campers.error;

// export const selectFilter = state => state.filter;
